import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  Admi10PkgComponent,
} from '../admi10/admi10Pkg.component';
import { JackBaseComponentModule } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { JkaggridComponent } from 'jk-advcom';

@Component({
  standalone: true,
  selector: 'app-admpi83',
  templateUrl: './admpi83.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
  ],
})
export class Admpi83Component extends Admi10PkgComponent implements OnInit {
  override _programId = 'admpi83'; // ###
  override isCheckPower = true;
  constructor() {
    super();

  }

  override ngOnInit() {
    super.ngOnInit();

  }
}
